var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"break-ad",style:({display: (_vm.showBreakAd ? 'block' : 'none')}),attrs:{"id":"break-ad"}},[_c('div',{staticClass:"gujAd",class:_vm.adType,attrs:{"id":_vm.adType+_vm.adSuffix}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2245d263","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ads/BreakAd.vue
// module id = null
// module chunks = 